import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCurrencyEuroCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM8 12c0-.17.01-.336.031-.5H11a1 1 0 1 0 0-2H8.877A3.993 3.993 0 0 1 12 8c1.025 0 1.958.384 2.666 1.018A1 1 0 0 0 16 7.528 6.001 6.001 0 0 0 6.544 9.5H6a1 1 0 0 0 0 2h.02a6.081 6.081 0 0 0 0 1H6a1 1 0 1 0 0 2h.544A6.001 6.001 0 0 0 16 16.472a1 1 0 1 0-1.334-1.49A3.981 3.981 0 0 1 12 16a3.992 3.992 0 0 1-3.123-1.5H11a1 1 0 1 0 0-2H8.031A4.039 4.039 0 0 1 8 12Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgCurrencyEuroCircle.displayName = 'CurrencyEuroCircle';
export default SvgCurrencyEuroCircle;
